module.exports = __webpack_public_path__ + "static/rainberry-hero-img-60175b3f5a72f94a5a1df04bc9e7a6fc.svg";